export enum FreshdeskCustomfieldsEnum {
  MM = 'cf_module',
  RP = 'cf_mydocma_rp',
  PX = 'cf_mydocma_px',
  Docuware = 'cf_docuware',
  BS = 'cf_mydocma_bs',
  LI = 'cf_mydocma_li',
  AP = 'cf_mydocma_ap',
  SO = 'cf_mydocma_so',
  SH = 'cf_mydocma_sh',
  Moduluebergreifend = 'cf_modulbergreifend'
}
